
import { ACCOUNT_STICKINESS, parseStickinessColumnKey } from '@/common/stickiness/stickiness.utils';

export const NAME_COLUMN = 'name';

export const DEFAULT_WIDGET_COLUMNS = Object.freeze([
    NAME_COLUMN,
    'visitors',
    'accounts',
    'newVisitors',
    'visitorRetention',
    'accountRetention',
    'numViews',
    'numClicks',
]);

export const PAGE_ONLY_COLUMNS = new Set(['checkbox', 'actions', 'context', 'feedback', 'ideas', 'validateFeedback']);

export function stripPageOnlyColumns (columns) {
    if (!Array.isArray(columns)) return undefined;

    return columns.filter((prop) => !PAGE_ONLY_COLUMNS.has(prop));
}

export const ACCOUNT_ONLY_COLUMNS = new Set(['accounts', 'newAccounts', 'accountRetention', 'newAccountRetention']);

export function isAccountOnlyColumn (prop) {
    if (ACCOUNT_ONLY_COLUMNS.has(prop)) return true;

    return parseStickinessColumnKey(prop)?.metricKey === ACCOUNT_STICKINESS;
}

export function defaultProductAreasListColumns (accountsEnabled = true) {
    return DEFAULT_WIDGET_COLUMNS.filter((prop) => accountsEnabled || !isAccountOnlyColumn(prop));
}

export function normalizeListColumns (columns, { accountsEnabled = true } = {}) {
    const kept = [];
    const seen = new Set([NAME_COLUMN]);

    (Array.isArray(columns) ? columns : []).forEach((prop) => {
        if (typeof prop !== 'string' || seen.has(prop)) return;
        if (PAGE_ONLY_COLUMNS.has(prop)) return;
        if (!accountsEnabled && isAccountOnlyColumn(prop)) return;

        seen.add(prop);
        kept.push(prop);
    });

    return [NAME_COLUMN, ...kept];
}

export function resolveListColumns (stored, { accountsEnabled = true } = {}) {
    if (Array.isArray(stored)) return normalizeListColumns(stored, { accountsEnabled });

    return defaultProductAreasListColumns(accountsEnabled);
}

export const SORT_ORDERS = Object.freeze(['ascending', 'descending']);

export const PRODUCT_AREAS_LIST_DEFAULT_SORT = Object.freeze({ prop: NAME_COLUMN, order: 'ascending' });

export function resolveListSort (sort, columns = []) {
    const prop = sort?.prop;
    const order = sort?.order;

    if (typeof prop === 'string' && columns.includes(prop) && SORT_ORDERS.includes(order)) {
        return { prop, order };
    }

    return { ...PRODUCT_AREAS_LIST_DEFAULT_SORT };
}
